import * as React from 'react'
import AvatarChat from '../components/AvatarStatic/AvatarChat';
import ChatContainer from '../components/chat/ChatContainer';
import TestComponent from '../components/chat/TestComponent';
import {Box, Grid2 as Grid } from '@mui/material'
import MosaicPresentation from '../components/chat/ContactMessage';


export default function TestPage() {
    return (
        <Box sx={{ flexGrow: 1, width: {xs:'100%', md:'90%'}, mt: 1, justifySelf: 'center' }}>
            <Grid container spacing={3} alignItems='start' justifyContent='center' justifyItems='center' sx={{ overflow: 'auto', height: '100dvh' }}>
                <MosaicPresentation />

            </Grid>
        </Box>
    );
}